import { contentBase as contentBaseSchema } from './content';
import { metadata } from './helpers';
import { z } from 'zod';

export const practiceAreasContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    title: z.string(),
    subtitle: z.string(),
    picture: z.string(),
    subheading: z.string(),
    description: z.string(),
    attributes: z.array(
      z.object({
        title: z.string(),
        content: z.string(),
      })
    ),
    content: z.string(),
  }),
});

export const contentTypePracticeAreasContentSchema = contentBaseSchema.extend({
  content: practiceAreasContentSchema,
});

export type ContentTypePracticeAreasContentInput = z.infer<
  typeof contentTypePracticeAreasContentSchema
>;
